
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { BusinessUnitId_$reflection, LocationId_$reflection } from "./Shared.js";
import { record_type, class_type, bool_type, option_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class Location extends Record {
    constructor(Id, Name, Description, ImageUrl, BusinessUnitId, BusinessUnitName, IsDeleted, CreatedAt, UpdatedAt) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.ImageUrl = ImageUrl;
        this.BusinessUnitId = BusinessUnitId;
        this.BusinessUnitName = BusinessUnitName;
        this.IsDeleted = IsDeleted;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}

export function Location_$reflection() {
    return record_type("Shared.Location.Location", [], Location, () => [["Id", LocationId_$reflection()], ["Name", string_type], ["Description", string_type], ["ImageUrl", string_type], ["BusinessUnitId", option_type(BusinessUnitId_$reflection())], ["BusinessUnitName", option_type(string_type)], ["IsDeleted", bool_type], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")]]);
}

export class LocationDetailDto extends Record {
    constructor(Id, Name, BusinessUnitName, BusinessUnitId, Description, ImageUrl) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.BusinessUnitName = BusinessUnitName;
        this.BusinessUnitId = BusinessUnitId;
        this.Description = Description;
        this.ImageUrl = ImageUrl;
    }
}

export function LocationDetailDto_$reflection() {
    return record_type("Shared.Location.LocationDetailDto", [], LocationDetailDto, () => [["Id", string_type], ["Name", string_type], ["BusinessUnitName", option_type(string_type)], ["BusinessUnitId", option_type(string_type)], ["Description", string_type], ["ImageUrl", string_type]]);
}

export class LocationCreateOrUpdateDto extends Record {
    constructor(Name, Description, BusinessUnitId) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.BusinessUnitId = BusinessUnitId;
    }
}

export function LocationCreateOrUpdateDto_$reflection() {
    return record_type("Shared.Location.LocationCreateOrUpdateDto", [], LocationCreateOrUpdateDto, () => [["Name", string_type], ["Description", string_type], ["BusinessUnitId", option_type(string_type)]]);
}

